import { ContactProps } from "../serviceDetailModal/Decription.Modal.props";
import {
	DesContent,
	Div
} from "../serviceDetailModal/Description.styled";

const IndustryNichesModal = ({
	bodyContent,
	data,
	industyData,
}: ContactProps) => {
	return (
		<Div className="des-container">
			{data && (
				<>
					<DesContent className="description">
						<DesContent>{industyData}</DesContent>
					</DesContent>
				</>
			)}
		</Div>
	);
};

export default IndustryNichesModal;
